module.exports = __webpack_public_path__ + "img/logo_footer.df869050.png";